import { Injectable } from '@angular/core';

import { StateSaver } from './state-storage.model';

@Injectable({
    providedIn: 'root',
})
export class StatePersistServiceRegistry {
    private readonly registry = new Map<string, StateSaver<any, any>>();

    register(feature: string, stateSaver: StateSaver<any, any>): void {
        this.registry.set(feature, stateSaver);
    }

    get(feature: string): StateSaver<any, any> | undefined {
        return this.registry.get(feature);
    }
}
